import { useUserData } from "@hooks/useUserData";
import { Suspense, lazy } from "react";

import { ThemeProvider } from "@components/shadcn/theme-provider";

import Loading from "@components/util/Loading";

import "./App.scss";

const AppInner = lazy(() => import("./AppInner"));
function App() {
  useUserData();

  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <Suspense fallback={<Loading />}>
        <AppInner />
      </Suspense>
    </ThemeProvider>
  );
}
App.whyDidYouRender = true;

export default App;
